export function getTemplateKits( state ) {
	return state.templates;
}

export function getLatestTemplateKits( state ) {
	return state.templates;
}

export function getTemplateData( state, id ) {
	return state.templatesData[ id ];
}
